import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationAffordanceContextType {
  showSupportAffordance: boolean;
  setShowSupportAffordance: (show: boolean) => void;
  showMenuHelpAffordance: boolean;
  setShowMenuHelpAffordance: (show: boolean) => void;
  showSecondMenuHelpAffordance: boolean;
  setShowSecondMenuHelpAffordance: (show: boolean) => void;
  hasAnyAffordance: () => boolean;
}

const NavigationAffordanceContext = createContext<NavigationAffordanceContextType | undefined>(undefined);

export const NavigationAffordanceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showSupportAffordance, setShowSupportAffordance] = useState(false);
  const [showMenuHelpAffordance, setShowMenuHelpAffordance] = useState(false);
  const [showSecondMenuHelpAffordance, setShowSecondMenuHelpAffordance] = useState(false);

  const hasAnyAffordance = () => {
    return showSupportAffordance || showMenuHelpAffordance || showSecondMenuHelpAffordance;
  };

  return (
    <NavigationAffordanceContext.Provider
      value={{
        showSupportAffordance,
        setShowSupportAffordance,
        showMenuHelpAffordance,
        setShowMenuHelpAffordance,
        showSecondMenuHelpAffordance,
        setShowSecondMenuHelpAffordance,
        hasAnyAffordance,
      }}
    >
      {children}
    </NavigationAffordanceContext.Provider>
  );
};

export const useNavigationAffordance = () => {
  const context = useContext(NavigationAffordanceContext);
  if (context === undefined) {
    throw new Error('useNavigationAffordance must be used within a NavigationAffordanceProvider');
  }
  return context;
}; 